const translations = {
    anErrorHasOccurred: 'An error has occurred'
};

export default translations;
